import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPC_CHANNEL } from '../../_offline/electron.constants';
import { AppInfoSchema } from '../../_offline/models/app-info.schema';
import { DatabaseBaseService } from '../base/database-base.service';
import { LoginUserOfflineService } from '../offline/login-user-offline.service';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class AppInfoDbService extends DatabaseBaseService {

  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  get(): Observable<AppInfoSchema>  {
    return this.ipcSendSync(IPC_CHANNEL.APP_INFO.GET, IPC_CHANNEL.APP_INFO.ID);
  }

  put(appInfo: AppInfoSchema): Observable<AppInfoSchema> {
    return this.ipcSendSync(IPC_CHANNEL.APP_INFO.PUT, appInfo);
  }

  putNetworkMode(isOnline: boolean): Observable<AppInfoSchema> {
    return this.ipcSendSync(IPC_CHANNEL.APP_INFO.PUT_NETWORK_MODE, isOnline);
  }

  putClientName(clientName: string): Observable<AppInfoSchema> {
    return this.ipcSendSync(IPC_CHANNEL.APP_INFO.PUT_CLIENT_NAME, clientName);
  }

  isAfterStartUp(): Observable<AppInfoSchema> {
    return this.ipcSendSync(IPC_CHANNEL.APP_INFO.AFTER_START_UP);
  }

  putSwitchOnlineBy(switchOnlineBy: string): Observable<boolean> {
    return this.ipcSendSync(IPC_CHANNEL.APP_INFO.PUT_SWITCH_BY, switchOnlineBy);
  }

  putEnvironment(): Observable<boolean> {
    return this.ipcSendSync(IPC_CHANNEL.APP_INFO.PUT_REGION);
  }

  putAppLaunchType(): Observable<AppInfoSchema> {
    return this.ipcSendSync(IPC_CHANNEL.APP_INFO.PUT_APP_LAUNCH_TYPE);
  }

  holdEnvironment(environment: string): Observable<boolean> {
    return this.ipcSendSync(IPC_CHANNEL.APP_INFO.HOLD_REGION, environment);
  }

  holdAppLaunchType(appLaunchType: string): Observable<AppInfoSchema> {
    return this.ipcSendSync(IPC_CHANNEL.APP_INFO.HOLD_APP_LAUNCH_TYPE, appLaunchType);
  }
}
